<micro-select-combo #sel
              placeholder="Alarm Filter"
              [mode]="mode"
              [(id)]="alarmFilterId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
